var exports = {
  "Zd": "x28a7bf27--4c60b0--form",
  "DD": "x28a7bf27--4c60b0--title",
  "hF": "x28a7bf27--4c60b0--input",
  "z3": "x28a7bf27--4c60b0--error",
  "pq": "x28a7bf27--4c60b0--info",
  "z6": "x28a7bf27--4c60b0--agreement",
  "x6": "x28a7bf27--4c60b0--button",
  "o2": "x28a7bf27--4c60b0--agreement-link",
  "kv": "x28a7bf27--4c60b0--checkbox",
};

module.exports = exports;
